import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { User } from "src/app/core/endpoints/models/user.model";
import { Service } from "src/app/core/endpoints/models/service";
import { Reservation } from "src/app/core/endpoints/models/reservation";
import { Extra } from "src/app/core/endpoints/models/extra";

@Component({
	selector: "app-calendar-services-list",
	templateUrl: "./calendar-services-list.component.html",
	styleUrls: ["./calendar-services-list.component.scss"],
})
export class CalendarServicesListComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;

	public schedules: any[] = [];
	public reservations: Reservation[] = [];
	public users: User[] = [];
	public services: Service[] = [];
	public servicesData: any = [];
	public extras: Extra[] = [];
	public extrasData: any = [];
	public loading: boolean = false;

	loggedUser : any = null;
	rangeDates : any = '';
	rangeDatesSelected: any = '';
	user_id:any = '';
	total:number = 0;
	total_completado:number = 0;
	total_no_completado:number = 0;
	total_en_espera:number = 0;

	constructor(
		private toast: ToastService,
		private apiService: ApiService,
		private authService: AuthenticationService,
		private confirmationService: ConfirmationService
	) {
		this.loggedUser = this.authService.getUser();
	}

	ngOnInit(): void {
		this.loadReservations();
		this.loadServices();
		this.loadExtras();
		if (this.loggedUser.role_id != 4){
			this.loadUsers();
		}
	}
	
	getUser() {
		return AuthService.getDataUser();
	}

	/**
	 * Limpiar filtros de búsqueda
	 * @param table
	 */
	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}

	public loadReservations() {
		this.loading = true;
		this.reservations = [];
		if (this.rangeDates == null || this.rangeDates == undefined){
			this.rangeDates = '';
			this.rangeDatesSelected = '';
		}
		this.apiService.getEntity("reservations?rangeDates="+this.rangeDatesSelected+'&userId='+this.user_id).subscribe({
			next: (result) => {
				this.total = result.total;
				this.total_completado = result.total_completado;
				this.total_no_completado = result.total_no_completado;
				this.total_en_espera = result.total_en_espera;
				
				this.reservations = result.reservations;
				this.loading = false;
			},
			error: (err) => {
				console.log(err);
				this.loading = false;
				this.toast.show(
					"Error",
					"Ocurrió un error obteniendo el listado de viviendas, inténtelo de nuevo",
					"error"
				);
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	formatSelectedDates() {
		this.rangeDatesSelected = '';
		try {
			if (Array.isArray(this.rangeDates) && this.rangeDates.length === 2) {
				const formatDate = (date: Date) => {
					const day = ('0' + date.getDate()).slice(-2);
					const month = ('0' + (date.getMonth() + 1)).slice(-2);
					const year = date.getFullYear();
					return `${year}-${month}-${day}`;
				};
		
				this.rangeDatesSelected = this.rangeDates.map(formatDate);
			}
		} catch (error) {
		}
	}
	
	public loadExtras() {
		this.apiService.getEntity("extras").subscribe({
			next: (result) => {
				this.extras = result.extras;
				this.extras.forEach(element => {
					this.extrasData[element.id] = element;
				});
			},
			error: (err) => {
			},
			complete: () => {
			},
		});
	}

	public loadServices() {
		this.apiService.getEntity("services?all=true").subscribe({
			next: (result) => {
				this.services = result.services;
				this.services.forEach(element => {
					this.servicesData[element.id] = element;
				});
			},
			error: (err) => {
			},
			complete: () => {
			},
		});
	}
	
	public loadUsers() {
		this.users = [{name_surname_email: 'Todos', id: ''}];
		this.loading = true;
		this.apiService.getEntity("users", 4).subscribe({
			next: (result) => {
				this.users = [{ name_surname_email: 'Todos', id: '' }, ...result.users];
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	public updateReservation(reservation,status) {
		if (this.loading) return;
		var message = '';
		if (status == 2){
			message = '¿Está seguro que desea procesar como "completada" esta reserva? No se puede deshacer';
		}
		if (status == 0){
			message = '¿Está seguro que desea procesar como "no completada" esta reserva? No se puede deshacer';
		}
		this.confirmationService.confirm({
			header:'Procesar reserva',
			message: message,
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.addEntity("processReservation", {
					id:reservation.id,
					status:status
				}).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Reserva procesada");
						this.loadReservations();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Error",
							"Ocurrió un error, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}
}
